import styled from 'styled-components/macro';
export const FasletButtonStyled = styled.button `
  border: none;
  padding: 0;
  margin: 0 0 0 auto;
  background: none;
  color: inherit;
  font: inherit;
  line-height: normal;
  overflow: visible;
  text-align: inherit;
  display: inline-block;

  &::-moz-focus-inner {
    border: 0;
    padding: 0;
  }
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
`;
